<header class="header" data-testid="app-header">
  <div class="header__left">
    <img class="header__logo-img" src="purplelab-logo.png" alt="PurpleLab" data-testid="header-logo" />
  </div>
  <div class="header__right">
    @if (canUseMockToggle) {
      <button 
        class="header__mock-toggle"
        [class.header__mock-toggle--active]="mockToggle.isMockEnabled()"
        (click)="toggleMock()"
        data-testid="button-mock-toggle"
        [title]="mockToggle.isMockEnabled() ? 'Mock data ON - click to use API' : 'API mode - click to use mock data'"
      >
        <span class="header__mock-indicator" [class.header__mock-indicator--on]="mockToggle.isMockEnabled()"></span>
        <span class="header__mock-label">{{ mockToggle.isMockEnabled() ? 'MOCK' : 'API' }}</span>
      </button>
    }
    <div class="header__menu-container">
      <button 
        class="header__menu-btn"
        (click)="toggleMenu()"
        data-testid="button-menu-toggle"
      >
      <ds-icon name="menu-hamburger" sizeIcon="s" />
      </button>
      
      @if (menuOpen()) {
        <div class="header__menu-backdrop" (click)="closeMenu()"></div>
        <nav class="header__dropdown" data-testid="nav-dropdown">
          <ds-menu class="header__ds-menu">
            <ds-menu-item class="header__user-item">
              <div class="header__user-card">
                <div class="header__user-name">{{ userDisplayName }}</div>
                <div class="header__user-email">{{ userDisplayEmail }}</div>
              </div>
            </ds-menu-item>

            <ds-menu-divider />
            <ds-menu-interactive-item (click)="portal()">
              Portal
            </ds-menu-interactive-item>
            @for (item of navItems; track item.route) {
              <ds-menu-interactive-item
                (click)="navigateTo(item.route)"
                [attr.data-testid]="'nav-' + item.label.toLowerCase().replace(' ', '-')"
              >
                {{ item.label }}
              </ds-menu-interactive-item>
            }

            

            <ds-menu-divider />

            <ds-menu-interactive-item
              class="header__logout-item"
              (click)="logout()"
              data-testid="button-logout"
            >
              <img src="assets/design-system/icons/20/log-out.svg" alt="" aria-hidden="true" />
              Logout
            </ds-menu-interactive-item>
          </ds-menu>
        </nav>
      }
    </div>
  </div>
</header>
